<template>
  <header
    class="fixed top-0 left-0 flex items-center justify-between flex-shrink-0 w-full py-4 bg-white border-b navigation z-header viewport-gutter color-white border-au_gray-150"
  >
    <div class="container flex items-center justify-between w-full">
      <nav>
        <a
          v-if="href"
          :href="href"
          class="block logo"
          aria-label="Austrian Airlines"
        />
        <router-link
          v-else
          :to="$i18nTo({ name: 'voucherSaleLanding' })"
          class="block logo "
          aria-label="Austrian Airlines"
        />
      </nav>
      <nav>
        <router-link
          class="focus:outline-none lang-link"
          :class="currentLocale === 'de' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: 'de'}}"
        >
          DE
        </router-link>

        <router-link
          class="focus:outline-none lang-link"
          :class="currentLocale === 'en' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: undefined}}"
        >
          EN
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import Header from '~brand-components/base/shared/header'

export default Header.extend()
</script>

<style lang="scss" scoped>
.navigation {
  height: 60px;
}

.pdf-include {
  background: url("../../../images/lufthansa/hero/white_pixel.jpg");
}

.logo {
  height: 40px;
  background: url("../../../images/austrian/logos/austrian.svg");
  background-position: left center;
  background-size: auto 24px;
  background-repeat: no-repeat;
  width: 168px;

  @screen md {
    background-size: auto 32px;
    width: 225px;
  }

  &:focus {
    outline: 1px solid black;
    outline-offset: 4px;

  }
}

.mobileNavButton {
  .lines{
    width: 27px;
    height: 14px;
    span {
      top: 0;
      height: 2px;
      &:nth-child(2) {
        top: 6px;
      }
      &:nth-child(3) {
        top: 12px;
      }
    }
  }
  &.active {
    .lines{
      span {
        top: 6px;
        &:first-child {
          @apply transform rotate-135;
          -ms-transform: rotate(135deg);
        }
        &:last-child {
          @apply transform -rotate-135;
          -ms-transform: rotate(-135deg);
        }
        &:nth-child(2) {
          opacity: 0;
        }
      }
    }
  }
}

.mobileNavigation {
  z-index: 49;
  right: 0;
  height: 100%;
}

.langSwitch{
  &:hover{
    .dropdown{
      @apply block;
    }
  }
}

@media screen and (min-width: 768px) {
  .navigation {
    height: 90px;
  }

  .mobileNavButton {
    .lines{
      width: 27px;
      height: 19px;
      span {
        &:nth-child(2) {
          top: 8px;
        }
        &:nth-child(3) {
          top: 17px;
        }
      }
    }
    &.active {
      .lines{
        span {
          top: 9px;
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) {
  .mobileNavigation{
    top: 90px;
    width: 100%;
    height: auto;
    @apply bg-gray-250;
  }
}

.lang-link {
  &:focus {
    outline: 1px solid black;
  }
}

</style>
